export default __webpack_public_path__ + "eef546aefd1d78b106e8d63a0fa9ffe6.svg";